import { h } from 'preact'
import { Model, TableRow } from './types'
import { defaultCellSize } from './Table'
import Checkbox from '../../control-components/ui-components/Checkbox'

type Props = {
  id?: string,
  cells: TableRow,
  model?: Model[] | null,
  displayFirstColumnBold?: boolean,
  isSelectable?: boolean,
  onSelectRow?: (rowId: number, checked: boolean) => void,
  isSelected?: boolean
}

const Row = ({ id, cells, model, displayFirstColumnBold = false, isSelectable, onSelectRow, isSelected }: Props) =>
  <tr id={id ? cells[id] : null} className={isSelected ? 'control-table__row--selected' : undefined}>
    {isSelectable && <th className='table-header--multiselect' scope='row'>
      <Checkbox
        qaClasses={`row-${id && cells[id]}`}
        onUpdate={() => id && onSelectRow && onSelectRow(cells[id], !isSelected)}
        checked={!!isSelected}
      />
    </th>}
    {model
      ? Object.keys(model).map((key: any) => {
        if (model[key].isHidden) {
          return
        }
        const { accessor, cell: customCell, size } = model[key]
        if (displayFirstColumnBold && key === '0') {
          return <th scope='row' className={`qa-${accessor} ${size || defaultCellSize}`}> {customCell ? customCell(cells) : accessor && cells[accessor]}</th>
        }
        return (
          <td className={`qa-${accessor} ${size || defaultCellSize}`}>
            {customCell ? customCell(cells) : accessor && cells[accessor]}
          </td>
        )
      })
      : Object.keys(cells).map((key) => {
        if (displayFirstColumnBold && key === '0' && !cells[key].colspan && cells[key].accessor !== 'tag-selector') {
          return <th scope='row' className={`qa-${cells[key].hasOwnProperty('accessor') ? cells[key].accessor : key} ${cells[key].size || defaultCellSize}`}>
            {cells[key].hasOwnProperty('cell') ? cells[key].cell : cells[key]}
          </th>
        }
        return (<td colSpan={cells[key].hasOwnProperty('colspan') ? cells[key].colspan : undefined}
          className={`qa-${cells[key].hasOwnProperty('accessor') ? cells[key].accessor : key} ${cells[key].size || defaultCellSize}`}>
          {cells[key].hasOwnProperty('cell') ? cells[key].cell : cells[key]}
        </td>)
      })
    }
  </tr>

export default Row
